<div class="c-placeholder-vertical">
  <div class="c-placeholder-vertical__cover"></div>

  <div class="c-placeholder-vertical__content">
    <div class="c-placeholder-vertical__avatar"></div>

    <span class="u-text-placeholder" style="width: 60%"></span>
    <span class="u-text-placeholder" style="width: 30%"></span>
  </div>
</div>
